<template>
  <v-container fluid class="e-block--default e-min-height align-end d-flex py-0">
    <v-layout row wrap >
      <v-flex xs12>
        <v-card color="white" class="primary--text elevation-0 e-block-auth">
          <div class="e-block-auth--image">
            <img src="../../assets/images/bg-tigre.png" alt="tigre-bg" >
            <div class="e-block-auth--image-content">
              <img src="../../assets/images/tigre-login.svg" alt="tigre-login" >
            </div>
          </div>
            <v-stepper v-model="e1" class="elevation-0 py-5 transparent no-transition">
              <v-stepper-header class="hidden-screen-only">
                <v-stepper-step :complete="e1 > 1" step="1">Name of step 1</v-stepper-step>
                <v-stepper-step :complete="e1 > 2" step="2">Name of step 2</v-stepper-step>
              </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card class="elevation-0 secondary--text text-xs-left" >
                  <h3 class="e-sub-sub-title-md" style="text-align: left !important">¿Olvidó su contraseña?</h3>
                  <p class="grey-light--text pt-2 parrafo">Escribe tu email y te enviaremos un enlace para restablecer tu contraseña rápidamente</p>
                </v-card>
                <v-form
                class="e-block--form"
                ref="form"
                v-model="valid"
                lazy-validation>
                  <label class="e-block--form--label text-xs-left">Email</label>
                  <v-text-field
                    v-model="form.email"
                    :rules="form.emailRules"
                    required
                    outline
                    placeholder="Ingresa tu email"
                    hide-details
                  ></v-text-field>
                  <v-btn
                  block
                  round
                  large
                  color="primary"
                  class="elevation-0 my-5"
                  @click="e1 = 2">
                    Siguiente
                  </v-btn>
                </v-form>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card class="elevation-0 secondary--text text-xs-left" >
                  <h3 class="e-sub-sub-title-md" style="text-align: left !important">Revisa tu correo</h3>
                  <div class="text-xs-center py-5">
                    <img src="../../assets/images/email.svg">
                  </div>
                  <p class="grey-light--text pt-2 parrafo">Te enviamos un mensaje con un link de confirmación.</p>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Login from '../../components/Auth/LoginForm'
import Registro from '../../components/Auth/RegistroForm'
export default {
  components: {
    Login,
    Registro
  },
  data () {
    return {
      valid: true,
      e1: 0,
      form: {
        passwordRules: [
          v => !!v || 'Contraseña es requerida',
          v => (v && /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])([A-Za-z\d$@$!%*?&]|[^ ]){8,15}$/.test(v)) || 'Contraseña inválida'
        ],
        email: '',
        emailRules: [
          v => !!v || 'Correo es requerido',
          v => /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Correo inválido'
        ]
		  }
    }
  }
}
</script>
